// Order matters (tokens -> Helix component CSS -> app CSS); blank lines keep organize-imports from re-sorting it.
import '@helix-ds/tokens/css'

import '@helix-ds/react/styles.css'

import '@/styles/globals.css'
import '@/styles/media.css'
import '@/styles/typography.css'
import { Button, Card } from '@helix-ds/react'
import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initializeSentry } from './sentry.config'

initializeSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* BASE_URL is '/' for every normal deploy and '/PR-<n>/' for a preview build, so the
        router resolves routes under whichever subpath the bundle was built for. One
        consequence: in a preview, /login/callback resolves to /PR-<n>/login/callback, which
        Auth0 can never redirect to (its allowlist takes no path wildcards), so that route
        is unreachable there. Previews sign in via the root callback and are navigated back;
        see features/auth/auth0/config/auth0.ts. */}
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => (
          <div className="bg-bg-secondary flex min-h-screen items-center justify-center">
            <Card padding="lg" className="text-center">
              <h1 className="text-text-fg-error mb-4 text-2xl font-bold">Something went wrong</h1>
              <p className="text-text-body mb-4">
                {error instanceof Error ? error.message : 'Please refresh the page to try again.'}
              </p>
              <div className="flex justify-center gap-4">
                <Button type="button" onClick={resetError}>
                  Try again
                </Button>
                <Button type="button" variant="secondary" onClick={() => window.location.reload()}>
                  Refresh page
                </Button>
              </div>
            </Card>
          </div>
        )}
        showDialog
      >
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
)
